export default class Number {
    constructor($wrapper) {
        this.$input = $wrapper.querySelector('[data-number-control]');
        this.min = this.$input.min ? parseInt(this.$input.min) : null;
        this.max = this.$input.max ? parseInt(this.$input.max) : null;
        this.$add = $wrapper.querySelector('[data-number-add]');
        this.$value = $wrapper.querySelector('[data-number-value]');
        this.$subtract = $wrapper.querySelector('[data-number-subtract]');
        this.$labelSingular = $wrapper.querySelector('[data-label-singular]');
        this.$labelPlural = $wrapper.querySelector('[data-label-plural]');
        this.$subtract = $wrapper.querySelector('[data-number-subtract]');
        this.hasOptions = $wrapper.hasAttribute('data-number-options');
        this.options = this.hasOptions ?
                JSON.parse($wrapper.dataset.numberOptions):
                [];

        this.add = this.add.bind(this);
        this.subtract = this.subtract.bind(this);
        this.renderValue = this.renderValue.bind(this);
        this.currentValue = this.currentValue.bind(this);

        this.$add.addEventListener('click', this.add);
        this.$subtract.addEventListener('click', this.subtract);

        // set the inital value
        this.renderValue();
    }

    add(e) {
        e.preventDefault()

        if (this.hasOptions) {
            const currentIndex = this.options.indexOf(this.currentValue())
            const indexOfNewValue = currentIndex + 1;

            this.$input.value = this.options[indexOfNewValue] !== undefined ?
                    this.options[indexOfNewValue]:
                    this.currentValue();
        } else {
            let newValue = this.currentValue() + 1;

            if(this.max !== null && this.max < newValue) {
                newValue = this.max;
            }
            this.$input.value = newValue;
        }

        this.renderValue();
    }

    subtract(e) {
        e.preventDefault()

        if (this.hasOptions) {
            const currentIndex = this.options.indexOf(this.currentValue())
            const indexOfNewValue = currentIndex - 1;

            this.$input.value = this.options[indexOfNewValue] !== undefined ?
                    this.options[indexOfNewValue]:
                    this.currentValue();
        } else {
            let newValue = this.currentValue() - 1;

            if(this.min !== null && this.min > newValue) {
                newValue = this.min;
            }
            this.$input.value = newValue;
        }

        this.renderValue();
    }

    currentValue() {
        return this.$input.value ?
                parseInt(this.$input.value):
                0;
    }

    renderValue() {
        if (this.currentValue() > 1) {
            this.$labelSingular.classList.add('d-none')
            this.$labelPlural.classList.remove('d-none')
        } else {
            this.$labelSingular.classList.remove('d-none')
            this.$labelPlural.classList.add('d-none')
        }

        this.$value.innerHTML = this.currentValue();

        // trigger the change event so we can react to it with the igredient-calculator
        var evt = document.createEvent("HTMLEvents");
        evt.initEvent("change", false, true);
        this.$input.dispatchEvent(evt);
    }
}